module.exports = __webpack_public_path__ + "img/elec2_hover.4c76c517.png";